import { EPNodeFieldsResolvers } from '../5-node/fields';
export const epExaminerFeedbackFieldsResolvers = {
    EPEF: EPNodeFieldsResolvers,
};
